import React, { Component } from 'react';
import renderHTML from 'react-render-html';

class DealerAddress extends Component {
	render() {
		const name = this.props.address.name;

		let address;
		if (this.props.address.address !== undefined && this.props.address.address.length > 0) {
			address = (
				<span><br />{ renderHTML(this.props.address.address) }</span>
			);
		}

		let phone;
		if (this.props.address.telephone !== undefined && this.props.address.telephone.length > 0) {
			phone = this.props.address.telephone;
			const phoneList = [];
			for (let ind = 0; ind < phone.length; ind++) {
				const option = phone[ind];
				let phoneName;
				if (option.name !== undefined) {
					phoneName = `${option.name}:  `;
				}
				phoneList.push(
					<span>
						<br />
							{phoneName}
							<a href={ `tel:${option.link}` }>
								{ option.display }
							</a>
					</span>
				);
			}

			phone = (
				phoneList 
			);
		}

		let fax;
		if (this.props.address.fax !== undefined && this.props.address.fax.length > 0) {
			fax = (
				<span><br />Fax: { this.props.address.fax }</span>
			);
		}

		let email;
		if (this.props.address.email !== undefined && this.props.address.email.length > 0) {
			email = this.props.address.email;
			email = (
				<span>
					<br />
					<a href={ `mailto:${email}` }>
						{ email }
					</a>
				</span>
			);
		}

		let website;
		if (this.props.address.website !== undefined && this.props.address.website.length > 0) {
			website = this.props.address.website;
			website = (
				<span>
					<br />
					<a href={ website } target="_blank">
						{ website }
					</a>
				</span>
			);
		}

		return (
			<div className="dealer-address">
				<b>{ name }</b>
				{ address }
				{ phone }
				{ fax }
				{ email }
				{ website }
			</div>
		);
	}
}

export default DealerAddress;


// WEBPACK FOOTER //
// ./src/pages/whereToBuy/DealerAddress.js